module.exports = __webpack_public_path__ + "front/img/p4.ad1cfdc8.png";